import { Component, IframeHTMLAttributes } from "react";
import classNames from "classnames";

import styles from "../../blocks/StandardTheme/styles/VideoBlock.module.scss";

interface IIframeVideoProps extends IframeHTMLAttributes<HTMLIFrameElement> {
  embedLink: string;
}

export default class IframeVideo extends Component<IIframeVideoProps> {
  render() {
    const { title, embedLink, ...validHtmlProps } = this.props;
    const embedResponsiveItemClassName = classNames({
      [styles.embedResponsiveItem]: true,
    });
    return (
      <iframe
        className={embedResponsiveItemClassName}
        title={title}
        src={embedLink}
        {...validHtmlProps}
      />
    );
  }
}
